




import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api';
@Component
export default class Rule extends Vue {
  obj: any = {};
  show: boolean = false;
  async created() {
    const res = await getRule();
    this.obj = res.data;
    if (res.data) {
      setTimeout(() => {
        this.show = true;
      }, 500);
    }
  }
}
